import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  constructor() { }

  guardarUsuarioStorage(usuario) {
    // //console.log(usuario);
    sessionStorage.setItem('user_info',usuario);
  }

  obtenerUsuarioStorage() {
    //console.log(JSON.parse(sessionStorage.getItem('user_info')));
    return JSON.parse(sessionStorage.getItem('user_info')) ;
  }

  limpiarUsuarioStorage() {
    sessionStorage.setItem('user_info',null);
  }

  guardarTokenStorage(token, expiration_time) {
    let fecha_actual = new Date();
    let fecha_expiracion = new Date(fecha_actual.getTime() + expiration_time*1000);
    // //console.log(fecha_expiracion.toJSON());
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('expiration_date', fecha_expiracion.toJSON());
  }

  obtenerTokenStorage() {
    let fecha_actual = new Date();
    // //console.log(fecha_actual.getTime());
    let data_fecha_expiracion_storage = sessionStorage.getItem('expiration_date');
    let token = sessionStorage.getItem('token');
    if (!data_fecha_expiracion_storage || !token) {
      let info = {
        valid_token: false,
      }
      return info;
    }
    let fecha_expiracion = new Date(data_fecha_expiracion_storage);
    // //console.log(fecha_expiracion.getTime());
    
    let tiempo_restante_expiracion = (fecha_expiracion.getTime() - fecha_actual.getTime()) / (1000*3600)
    // //console.log(tiempo_restante_expiracion);
    
    let valid_token = tiempo_restante_expiracion > 8 ? true : false;

    let info = {
      token: sessionStorage.getItem('token'),
      expiration_date: fecha_expiracion,
      valid_token: valid_token,
    }
    return info;
  }

  limpiarTokenStorage() {
    sessionStorage.setItem('token', null);
    sessionStorage.setItem('expiration_date', null);
  }

}
